import { Hidden, useMediaQuery } from "@material-ui/core"
import { Theme } from "theme/theme"

import React from "react"
import styled from "styled-components"

const StyledHidden = styled(Hidden)<{
  children: React.ReactNode
  className?: string
}>``

export type MediaQueryComponentProps = {
  aboveTheFold?: boolean
  children?: React.ReactNode
  className?: string
}
export const useCustomQuery = (minWidth: number) =>
  useMediaQuery(`(min-width:${minWidth}px)`)

export const useIsDesktop = () =>
  useMediaQuery<Theme>((theme) => theme.breakpoints.up("md"))

// export const Mobile = ({ children }: MediaQueryComponentProps) => {
//   const isDesktop = useIsDesktop()
//   return isDesktop ? null : <>{children}</>
// }

// export const Desktop = ({ children }: MediaQueryComponentProps) => {
//   const isDesktop = useIsDesktop()
//   return isDesktop ? <>{children}</> : null
// }

export const Mobile = ({
  children,
  aboveTheFold = false,
  className,
}: MediaQueryComponentProps) => (
  // todo ask gil about aboove the fols css its critical
  <StyledHidden
    className={className}
    implementation={aboveTheFold ? "css" : "js"}
    mdUp
  >
    {children}
  </StyledHidden>
)

export const Desktop = ({
  children,
  aboveTheFold = false,
  className,
}: MediaQueryComponentProps) => (
  <StyledHidden
    className={className}
    implementation={aboveTheFold ? "css" : "js"}
    smDown
  >
    {children}
  </StyledHidden>
)

export const IEMediaQuery =
  "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)"

export const EdgeMediaQuery = "@supports (-ms-ime-align:auto)"
